// SLC COATINGS GT LAB PAGE - JS
document.addEventListener('DOMContentLoaded', function () {
  const wrappers = document.querySelectorAll('.gt-before-after');

  wrappers.forEach(function (wrapper) {
    const after = wrapper.querySelector('.gt-after');
    const slider = wrapper.querySelector('.gt-slider');

    if (!after || !slider) return;

    let isDragging = false;

    function moveSlider(clientX) {
      const rect = wrapper.getBoundingClientRect();
      let position = ((clientX - rect.left) / rect.width) * 100;

      position = Math.max(0, Math.min(100, position));

      after.style.width = position + '%';
      slider.style.left = position + '%';
    }

    slider.addEventListener('mousedown', function () {
      isDragging = true;
    });

    window.addEventListener('mouseup', function () {
      isDragging = false;
    });

    window.addEventListener('mousemove', function (event) {
      if (!isDragging) return;
      moveSlider(event.clientX);
    });

    slider.addEventListener('touchstart', function () {
      isDragging = true;
    });

    window.addEventListener('touchend', function () {
      isDragging = false;
    });

    window.addEventListener('touchmove', function (event) {
      if (!isDragging) return;
      moveSlider(event.touches[0].clientX);
    });

    wrapper.addEventListener('click', function (event) {
      moveSlider(event.clientX);
    });
  });
});